export default __webpack_public_path__ + "static/media/telegram-icon.8a20a557.svg";